var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 35"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 5962",
    cx: 9.73623,
    cy: 10.0003,
    rx: 6.05263,
    ry: 7.36842,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 1.0625C8.8262 1.06209 7.66381 1.29298 6.57928 1.74199C5.49475 2.191 4.50932 2.84931 3.67932 3.67932C2.84931 4.50932 2.191 5.49475 1.74199 6.57928C1.29298 7.66381 1.06209 8.8262 1.0625 10C1.06209 11.1738 1.29298 12.3362 1.74199 13.4207C2.191 14.5053 2.84931 15.4907 3.67932 16.3207C4.50932 17.1507 5.49475 17.809 6.57928 18.258C7.66381 18.707 8.8262 18.9379 10 18.9375C11.1738 18.9379 12.3362 18.707 13.4207 18.258C14.5053 17.809 15.4907 17.1507 16.3207 16.3207C17.1507 15.4907 17.809 14.5053 18.258 13.4207C18.707 12.3362 18.9379 11.1738 18.9375 10C18.9379 8.8262 18.707 7.66381 18.258 6.57928C17.809 5.49475 17.1507 4.50932 16.3207 3.67932C15.4907 2.84931 14.5053 2.191 13.4207 1.74199C12.3362 1.29298 11.1738 1.06209 10 1.0625ZM10 16.4375C9.73273 16.4381 9.47129 16.3594 9.24881 16.2113C9.02632 16.0632 8.85281 15.8524 8.75024 15.6056C8.64768 15.3588 8.62068 15.0871 8.67267 14.8249C8.72466 14.5627 8.8533 14.3219 9.04228 14.1329C9.23127 13.9439 9.47211 13.8153 9.73427 13.7633C9.99644 13.7113 10.2681 13.7383 10.5149 13.8409C10.7618 13.9434 10.9726 14.1169 11.1207 14.3394C11.2688 14.5619 11.3475 14.8234 11.3469 15.0906C11.3461 15.4476 11.2039 15.7897 10.9515 16.0421C10.6991 16.2945 10.357 16.4367 10 16.4375ZM11.6344 5.3125L11.125 12.1875C11.1218 12.235 11.1007 12.2796 11.0659 12.3121C11.031 12.3446 10.9851 12.3626 10.9375 12.3625H9.0625C9.01486 12.3626 8.96897 12.3446 8.93415 12.3121C8.89932 12.2796 8.87818 12.235 8.875 12.1875L8.36563 5.3125C8.35182 5.08937 8.38385 4.86578 8.45974 4.6555C8.53563 4.44522 8.65378 4.2527 8.8069 4.08982C8.96002 3.92693 9.14487 3.79712 9.35006 3.70839C9.55526 3.61966 9.77644 3.57388 10 3.57388C10.2236 3.57388 10.4447 3.61966 10.6499 3.70839C10.8551 3.79712 11.04 3.92693 11.1931 4.08982C11.3462 4.2527 11.4644 4.44522 11.5403 4.6555C11.6161 4.86578 11.6482 5.08937 11.6344 5.3125Z",
    fill: "#F25F5C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.07aa40a3ee2b55e9a47b8fa14a062a93.svg";
export { ForwardRef as ReactComponent };